import { createQueryKeys } from '@lukemorales/query-key-factory';

import {
    getCustomerGroups as getCustomerGroupsList,
    getCustomerGroupSettings,
    GetCustomerGroupsParams,
} from '../clients/company.api';
import { getCustomerGroup, getCustomerGroups } from '../clients/customerGroups.api';

export const customerGroups = createQueryKeys('customerGroups', {
    detail: (id: string) => ({
        queryKey: [id],
        queryFn: () => getCustomerGroup(id),
        contextQueries: {
            settings: {
                queryKey: null,
                queryFn: () => getCustomerGroupSettings(id),
            },
        },
    }),
    pagination: (params: { searchQuery: string; page: number }) => ({
        queryKey: [{ params }],
        queryFn: () => getCustomerGroups(params.searchQuery, params.page),
    }),
    list: (params?: GetCustomerGroupsParams) => ({
        queryKey: [{ params }],
        queryFn: () => getCustomerGroupsList(params || {}),
    }),
    comboBoxOptions: (params: GetCustomerGroupsParams) => ({
        queryKey: [{ params }],
    }),
    selectedComboBoxOption: (customerGroupId: string) => ({
        queryKey: [customerGroupId],
    }),
});
